<template>
  <div class="animated fadeIn" id="hssk-page">
    <div class="card">
      <div class="card-header">
        Hồ sơ sức khỏe cá nhân hl7
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataFormDoctor"
          :rules="mData.validFormDoctor"
          ref="myFormDoctor"
          label-width="100%"
          label-position="top"
          @submit.native.prevent
        >
          <b-row
            v-if="
              (aRole('Hospital') || aRole('Doctor_His')) && mData.showCardCode
            "
          >
            <b-col md="4">
              <el-form-item label="Nhập mã thẻ" props="cardCode">
                <el-input
                  v-model.trim="mData.dataFormDoctor.cardCode"
                  clearable
                  placeholder="Nhấn enter để tìm kiếm"
                  @keyup.enter.native="
                    fn_getDotKhamByCardCode(mData.dataFormDoctor.cardCode)
                  "
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-button
                class="noLabel"
                type="info"
                plain
                @click="fn_getDotKhamByCardCode(mData.dataFormDoctor.cardCode)"
                >{{ aLang.c_detail }}</el-button
              >
            </b-col>
          </b-row>
        </el-form>
        <el-timeline class="mt-1">
          <el-timeline-item
            v-for="(item, index) in mData.listData"
            :key="index"
            color="#3598DC"
            icon="fa fa-stethoscope"
            size="large"
            :timestamp="
              'Thời gian điều trị: ' +
              (item.ngay_bat_dau != item.ngay_ket_thuc
                ? item.ngay_bat_dau + ' - ' + item.ngay_ket_thuc
                : item.ngay_bat_dau)
            "
            placement="top"
          >
            <b-row class="mt-2 ml-4">
              <b-col md="12">
                <span class="bold-500">Tên cơ sở:</span> {{ item.noi_kham }}
              </b-col>
              <b-col md="12">
                <span class="bold-500">Khoa điều trị:</span>
                {{ item.khoa_dieu_tri }}
              </b-col>
              <b-col md="12">
                <span class="bold-500">Chẩn đoán bệnh:</span>
                {{ item.ten_benh }}
              </b-col>
              <b-col md="12" class="mt-2">
                <el-button
                  type="primary"
                  v-if="aRole('Hospital') || aRole('Doctor_His')"
                  plain
                  @click="fn_checkViewDetail(item)"
                  >{{ aLang.c_detail }}</el-button
                >
                <el-button
                  type="primary"
                  v-if="aRole('Citizen')"
                  plain
                  @click="fn_openModalDetail(item)"
                  >{{ aLang.c_detail }}</el-button
                >
              </b-col>
            </b-row>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <!-- modal chi tiet-->
    <el-dialog
      :title="
        'Chi tiết điều trị từ ngày ' +
        mData.dialogDetail.data.ngay_bat_dau +
        ' tại ' +
        mData.dialogDetail.data.noi_kham
      "
      :visible.sync="mData.dialogDetail.visibleDialog"
      width="70%"
      top="51px"
      append-to-body
      :close-on-click-modal="false"
    >
      <hssk-h-l7-form
        :prop-data-form="mData.dialogDetail"
        @changeData="changeData($event)"
      ></hssk-h-l7-form>
    </el-dialog>

    <!-- modal check quuyen-->
    <el-dialog
      :title="'Xin quyền truy cập'"
      :visible.sync="mData.dialogCheckQuyen.visibleDialog"
      width="50%"
      top="51px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <el-form
          :model="mData.dataFormCheckQuyen"
          :rules="mData.validFormCheckQuyen"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12" v-if="mData.dataFormCheckQuyen.status == 'chuaGui'"
              >Bấm gửi mã OTP để gửi mã tới điện thoại của bệnh nhân</b-col
            >
          </b-row>

          <b-row v-if="mData.dataFormCheckQuyen.status == 'choXacNhan'">
            <b-col md="12" class="mb-2">
              Đã gửi thành công tới số điện thoại:
              {{ mData.dataFormCheckQuyen.mobile }} <br />Yêu cầu bệnh nhân đọc
              mã OTP để được cấp quyền truy cập
            </b-col>
            <b-col md="6">
              <el-form-item label prop="code" class="mb-1">
                <el-input
                  v-model.trim="mData.dataFormCheckQuyen.otp"
                  clearable
                  placeholder="Nhập mã OTP"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'guiKhongThanhCong'"
              >Gửi mã OTP đến số
              {{
                mData.dataFormCheckQuyen.mobile
                  ? mData.dataFormCheckQuyen.mobile
                  : "điện thoại"
              }}
              không thành công</b-col
            >
          </b-row>

          <b-row>
            <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'xacNhanKhongThanhCong'"
              >Mã OTP không đúng hoặc đã hết hạn</b-col
            >
          </b-row>

          <b-row>
            <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'xacNhanThanhCong'"
              >Bạn đã được cấp quyền xem y bạ điện tử của mã thẻ
              {{ mData.dataFormDoctor.cardCode }} trong vòng 24 giờ</b-col
            >
          </b-row>

          <b-row>
            <b-col md="12" class="text-center mt-3">
              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'chuaGui'"
                type="info"
                plain
                @click="fn_sendCode()"
                >Gửi mã OTP</el-button
              >

              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'choXacNhan'"
                type="info"
                plain
                @click="fn_confirmCode()"
                >Xác nhận</el-button
              >

              <el-button
                v-if="
                  mData.dataFormCheckQuyen.status == 'xacNhanKhongThanhCong'
                "
                type="info"
                plain
                @click="fn_sendCodeAgain()"
                >Gửi lại</el-button
              >

              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'guiKhongThanhCong'"
                type="info"
                plain
                @click="fn_backSendCode()"
                >{{ aLang.c_back }}</el-button
              >

              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'xacNhanThanhCong'"
                type="info"
                plain
                @click="fn_continue()"
                >Tiếp tục</el-button
              >

              <el-button
                @click="mData.dialogCheckQuyen.visibleDialog = false"
                type="info"
                plain
                >{{ aLang.c_close }}</el-button
              >
            </b-col>
          </b-row>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Chi tiết kết quả ngày ' + mData.dialogDetail.dateSelect"
      :visible.sync="mData.dialogDetail.visibleDialogXN"
      width="70%"
      top="51px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="card-body p-0">
        <b-col md="12" class="p-0">
          <b-tabs
            card
            pills
            vertical
            width="100%"
            nav-wrapper-class="w-40"
            v-model="tabIndex[1]"
          >
            <b-tab active style="max-height: 80vh; overflow: auto">
              <div v-if="mData.dialogDetail.dataXetNghiem[0].table.length == 0" class="text-center">
                <span>Không có thông tin xét nghiệm</span>
              </div>
              <template slot="title">Xét nghiệm</template>
              <!-- <template> -->
              <el-table
                :data="mData.dialogDetail.dataXetNghiem[0].table"
                :span-method="objectSpanMethod"
                border
                style="width: 100%"
                v-if="mData.dialogDetail.dataXetNghiem[0].table.length > 0"
              >
                <el-table-column label="Tên dịch vụ">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.service_name }}
                      </p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Tên tiêu chí"
                >
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.criteria_name }}
                      </p>
                    </div>
                    <!-- {{ scope.row.criteria_name }} -->
                  </template>
                </el-table-column>

                <el-table-column label="Mô tả">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.mo_ta }}
                      </p>
                    </div>
                  </template>
                </el-table-column>
                
                <el-table-column label="Đơn vị">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.row.unit }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Kết quả">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.row.result }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Kết quả bình thường">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.row.result_ }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Kết luận">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.ket_luan }}
                      </p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- </template> -->
            </b-tab>
            <b-tab style="max-height: 80vh; overflow: auto">
              <div v-if="mData.dialogDetail.dataOther.length == 0" class="text-center">
                <span>Không có thông tin</span>
              </div>
              <template slot="title">Khác</template>
              <el-timeline class="mt-1">
                <el-timeline-item
                  v-for="(item, index) in mData.dialogDetail.dataOther"
                  :key="index"
                  color="#3598DC"
                  size="large"
                  placement="top"
                >
                  <b-row class="mt-2 ml-3">
                    <b-col md="12">
                      <b-col md="12" class="mt-2" v-if="item.service_name">
                        <span class="bold-500">Dịch vụ:</span>
                        <p style="white-space: pre-line">
                          {{ `${item.service_name || ""}` }}
                        </p>
                      </b-col>
                      <b-col md="12" class="pb-2" v-if="item.description">
                        <span class="bold-500">Mô tả:</span>
                        <p style="white-space: pre-line">
                          {{ `${item.description}` }}
                        </p>
                      </b-col>
                      <b-col md="12" class="pb-2" v-if="item.result">
                        <span class="bold-500">Kết luận:</span>
                        <p style="white-space: pre-line">
                          {{ `${item.result}` }}
                        </p>
                      </b-col>
                    </b-col>
                  </b-row>
                </el-timeline-item>
              </el-timeline>
            </b-tab>
          </b-tabs>
        </b-col>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
// import Hssk4210Api from "../../../moduleApi/Hssk4210Api";
import HsskHL7Api from "../../../moduleApi/HsskHL7Api";
import HsskHL7Model from "./HsskHL7Model";
import HsskHL7Form from "./HsskHL7Form";
import ApiServiceAxios from "../../../service/ApiServiceAxios";
import moment from "moment";
import { Buffer } from "buffer";
import COSApi from "../../../moduleApi/COSApi";
export default {
  components: { HsskHL7Form },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "HsskHL7", //requied
        listData: [],

        dataFormDoctor: MethodService.copyObject(HsskHL7Model.dataFormDoctor),
        validFormDoctor: MethodService.copyObject(HsskHL7Model.validFormDoctor),

        validFormCheckQuyen: MethodService.copyObject(
          HsskHL7Model.validFormCheckQuyen
        ),
        dataFormCheckQuyen: MethodService.copyObject(
          HsskHL7Model.dataFormCheckQuyen
        ),

        showCardCode: true,
        actived: [],
        dialogDetail: {
          visibleDialog: false,
          visibleDialogXN: false,
          data: MethodService.copyObject(HsskHL7Model.dataModalDetail),
          dataTabAll: null,
          cardCode: "",
          dataXetNghiem: [
            {
              table: [],
            },
          ],
          dataOther: [],
          dateSelect: "",
          dataMergeCol:[]
        },
        dialogCheckQuyen: {
          visibleDialog: false,
          status: "xacNhanThanhCong",
        },
      },
      tabIndex: [0, 0],
    };
  },

  methods: {
    changeData(data) {
      let dataXetNghiem = [];
      let dataOther = [];
      data.result_data.forEach((element) => {
        if (element.type_service == "Xét nghiệm") {
          dataXetNghiem.push(element);
        } else {
          dataOther.push(element);
        }
      });
      if(dataXetNghiem.length>0){
        dataXetNghiem[0].table = dataXetNghiem[0].table.sort(function (a, b) {
              return a.service_name.localeCompare(b.service_name);
          });
        
        let dataMergeCol = [];
        dataXetNghiem[0].table.forEach((elXN, index) => {
          let findXN = dataMergeCol.find((el) => el.key == elXN.service_name);
          if (!findXN) {
            let data = {
              key: elXN.service_name,
              count: 1,
              rowIndex: index,
            };
            dataMergeCol.push(data);
          } else {
            let findIndex = dataMergeCol.findIndex(
              (elMerge) => elMerge.key == findXN.key
            );
            dataMergeCol[findIndex].count += 1;
          }
        });
        this.mData.dialogDetail.dataMergeCol = dataMergeCol;
      }
      this.mData.dialogDetail.dataXetNghiem =
        dataXetNghiem.length > 0 ? dataXetNghiem : [{ table: [] }];
      this.mData.dialogDetail.dataOther = dataOther;
      this.mData.dialogDetail.dateSelect = data.date;
      this.mData.dialogDetail.visibleDialogXN = true;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (this.mData.dialogDetail.dataMergeCol.length > 0) {
          let find = this.mData.dialogDetail.dataMergeCol.find(
            el => el.rowIndex == rowIndex
          );
          if (find) {
            return {
              rowspan: find.count,
              colspan: 1,
            }
          }else{
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
    async fn_initData() {
      if (
        (MethodService.checkRole("Hospital") ||
          MethodService.checkRole("Doctor_His")) &&
        this.$router.currentRoute.query.cardCode
      ) {
        this.mData.dataFormDoctor.cardCode =
          this.$router.currentRoute.query.cardCode;
        this.mData.showCardCode = false;
        let response = await COSApi.GetInfoUser(
          this.mData.dataFormDoctor.cardCode
        );
        if (response.data && response.data.Data && response.data.Data[0]) {
          this.DataHealthRecord(response.data.Data[0]);
        } else {
          toastr.warning("Không tìm thấy thông tin!");
        }
      } else if (
        !(
          MethodService.checkRole("Hospital") ||
          MethodService.checkRole("Doctor_His")
        ) &&
        this.$router.currentRoute.query.cardCode
      ) {
        toastr.warning("Tài khoản không có quyền xem chức năng này");
      } else if (
        MethodService.checkRole("Citizen") &&
        !this.$router.currentRoute.query.cardCode
      ) {
        // let currentUser = MethodService.getCurrentUser();
        let dataUser = window.localStorage.getItem("dataUser");
        dataUser = dataUser ? JSON.parse(dataUser) : {};
        this.DataHealthRecord(dataUser);
      } else {
        let currentUser = MethodService.getCurrentUser();
        if (window.localStorage.getItem("activedOTP")) {
          let cache = JSON.parse(window.localStorage.getItem("activedOTP"));
          if (cache[currentUser.account]) {
            this.mData.actived = cache[currentUser.account].filter((card) => {
              return (
                new Date().getTime() - new Date(card.time).getTime() <
                24 * 60 * 60 * 1000
              );
            });
            if (this.mData.actived.length == 0) {
              delete cache[currentUser.account];
            } else {
              cache[currentUser.account] = this.mData.actived;
            }
            window.localStorage.setItem("activedOTP", JSON.stringify(cache));
          } else {
            this.mData.actived = [];
          }
        } else {
          this.mData.actived = [];
        }
      }
    },

    async fn_getDotKhamByCardCode(cardCode) {
      this.mData.dataFormDoctor.cardCode = cardCode;
      this.mData.showCardCode = false;
      let response = await COSApi.GetInfoUser(cardCode);
      if (response.data && response.data.Data && response.data.Data[0]) {
        this.DataHealthRecord(response.data.Data[0]);
      } else {
        toastr.warning("Không tìm thấy thông tin!");
      }
    },

    fn_mergerDataHL7(data) {
      var arrNew = [];
      if (!data || data.length == 0 || data[0] == null) {
        toastr.info("Chưa có thông tin");
        return;
      }
      // for sở
      data.forEach((el) => {
        if (el == null) return;
        if (
          !el.ApiResult.ThongTinVaoVien ||
          el.ApiResult.ThongTinVaoVien.length == 0
        ) {
          toastr.info("Chưa có thông tin");
          return;
        }
        el.ApiResult.ThongTinVaoVien.forEach((item) => {
          let obj = {
            SidCode: el.SidCode,
            idDotKhamChuaBenh: item.Encounter.IdElement
              ? item.Encounter.IdElement.Value
              : "",
            TenCoSo: `${
              item.Organization && item.Organization.NameElement
                ? item.Organization.NameElement.Value
                : ""
            }`,
            ThoiGianDieuTri: ``,
            TenBenh: `${
              item.Condition.Code ? item.Condition.Code.TextElement.Value : ""
            }`,
            KhoaDieuTri: `${
              item.Location.NameElement ? item.Location.NameElement.Value : ""
            }`,
          };

          if (
            item.Encounter.Period.StartElement &&
            item.Encounter.Period.StartElement.Value
          ) {
            let StartElement = MethodService.formatDate(
              item.Encounter.Period.StartElement.Value,
              "datetime"
            );
            obj.ThoiGianDieuTri += StartElement;
          }
          if (
            item.Encounter.Period.EndElement &&
            item.Encounter.Period.EndElement.Value
          ) {
            let EndElement = MethodService.formatDate(
              item.Encounter.Period.EndElement.Value,
              "datetime"
            );
            obj.ThoiGianDieuTri += ` - ${EndElement}`;
          }

          arrNew.push(obj);
        });
      });

      return arrNew;
    },

    //quyền bệnh nhân, tự xem detail
    fn_openModalDetail(item) {
      this.mData.dialogDetail.data = MethodService.copyObject(item);
      this.mData.dialogDetail.visibleDialog = true;
      this.$store.commit("fn_reloadModalDetailHL7");
    },

    //bác sỹ xem detail
    fn_checkViewDetail(item) {
      let cache = this.mData.actived.filter((card) => {
        return (
          card.cardCode == this.mData.dataFormDoctor.cardCode &&
          new Date().getTime() - new Date(card.time).getTime() <
            24 * 60 * 60 * 1000
        );
      });
      if (cache.length == 0) {
        toastr.info("Bạn cần xin quyền truy cập");
        this.mData.dialogDetail.dataTabAll = null;
        this.mData.dialogCheckQuyen.visibleDialog = true;
        this.mData.item = item;
        this.fn_resetModal();
      } else {
        this.mData.dialogDetail.data = MethodService.copyObject(item);
        this.mData.dialogDetail.cardCode = this.mData.dataFormDoctor.cardCode;
        this.mData.dialogDetail.visibleDialog = true;
        this.$store.commit("fn_reloadModalDetailHL7");
        // HsskHL7Api.chiTietLanKham(
        //   this.mData.dialogDetail.data.idDotKhamChuaBenh,
        //   this.mData.dialogDetail.cardCode,
        //   "hiddenMessage"
        // ).then(
        //   (res) => {
        //     this.mData.dialogDetail.dataTabAll = res.result;
        //     this.mData.dialogDetail.visibleDialog = true;
        //     this.$store.commit("fn_reloadModalDetailHL7");
        //   },
        //   (err) => {
        //     toastr.error(LanguageService.lang.c_findError);
        //   }
        // );
      }
    },

    fn_continue() {
      this.mData.dialogCheckQuyen.visibleDialog = false;
      this.fn_resetModal();
      this.mData.dialogDetail.visibleDialog = false;
    },

    async fn_sendCode() {
      this.fn_resetModal();
      try {
        let res = await HsskHL7Api.requestOtp(
          this.mData.dataFormDoctor.cardCode
        );
        this.mData.dataFormCheckQuyen.status = "choXacNhan";
        this.mData.dataFormCheckQuyen.mobile = res.result.mobile;
      } catch (error) {
        this.mData.dataFormCheckQuyen.status = "guiKhongThanhCong";
      }

      // test
      // this.mData.dataFormCheckQuyen.status = "choXacNhan";
    },

    async fn_confirmCode() {
      this.mData.dataFormCheckQuyen.status = "choXacNhan";
      try {
        let res = await HsskHL7Api.validateOtp(
          this.mData.dataFormDoctor.cardCode,
          this.mData.dataFormCheckQuyen.otp
        );
        this.mData.dataFormCheckQuyen.status = "xacNhanThanhCong";
        this.mData.actived.push({
          cardCode: this.mData.dataFormDoctor.cardCode,
          time: new Date().getTime(),
        });
        let cache = {};
        let currentUser = MethodService.getCurrentUser();
        if (window.localStorage.getItem("activedOTP")) {
          cache = JSON.parse(window.localStorage.getItem("activedOTP"));
        }
        cache[currentUser.account] = this.mData.actived;
        window.localStorage.setItem("activedOTP", JSON.stringify(cache));
      } catch (error) {
        this.mData.dataFormCheckQuyen.status = "xacNhanKhongThanhCong";
      }

      // test
      // this.mData.dataFormCheckQuyen.status = "xacNhanThanhCong";
    },

    fn_sendCodeAgain() {
      this.fn_resetModal();
    },

    fn_backSendCode() {
      this.fn_resetModal();
    },

    fn_resetModal() {
      this.mData.dataFormCheckQuyen.status = "chuaGui";
      this.mData.dataFormCheckQuyen.mobile = "";
    },

    async fn_getAllDomain(people_code) {
      let token = await localStorage.getItem(
        "mushroom.tokens[" + window.MyConfig.hostApi + "]"
      );
      let dataDomain = [];
      try {
        let dataRegister = {
          ApiData: {
            PeopleCode: people_code,
            DomainTypeId: 1,
          },
        };
        console.log(window.MyConfig);
        let string = JSON.stringify(dataRegister);
        let param = Buffer.from(string).toString("base64");
        var reqDomain = await ApiServiceAxios(
          // `http://14.232.245.104:8701/api/LocDomainConfig/GetByPeople?param=${param}`,
          {
            method: "get",
            headers: {
              "Content-Type": "application/json",
              AppCode: window.MyConfig.applicationCode831,
              TokenCode: token,
            },
            url: `${window.MyConfig.locUrl}api/LocDomainConfig/GetByPeople?param=${param}`,
          }
        );
        var resDomain = await reqDomain.data;
        if (resDomain && resDomain.Data && resDomain.Data.length > 0) {
          dataDomain = resDomain.Data;
        } else {
          // this.setState({ loading: false });
        }
      } catch (err) {
        // this.setState({ loading: false });
        // console.log("err", err);
      }
      return dataDomain;
    },
    checkSaveDataLocal(dataLocalHealthRecord, people_code) {
      let isSaved = false;
      if (dataLocalHealthRecord) {
        let dataLocal = JSON.parse(dataLocalHealthRecord);
        if (dataLocal.dataLocalHealthRecord.length > 0) {
          isSaved = false;
          for (let i = 0; i < dataLocal.dataLocalHealthRecord.length; i++) {
            let item = dataLocal.dataLocalHealthRecord[i];
            if (item.peopleCode == people_code) {
              isSaved = true;
              break;
            }
          }
        }
      }
      return isSaved;
    },
    async DataHealthRecord(data) {
      let body = {
        HoTen: data.FullName ? data.FullName : "",
        NgaySinh: data.Dob
          ? moment(data.Dob, "YYYYMMDD000000").format("YYYYMMDD")
          : "",
        GioiTinh: data.GenderId == 2 ? 1 : 2,
        SoCMND: data.CmndNumber ? data.CmndNumber : "",
        SoTheBHYT:
          data.Bhyts && data.Bhyts.length > 0 && data.Bhyts[0].BhytNumber
            ? data.Bhyts[0].BhytNumber
            : "",
        DiaChi: `${data.CommuneName},${data.DistrictName},${data.ProvinceName}`,
      };
      // console.log("body", body);
      let token = MethodService.getToken();
      let dataLocalHealthRecord = await localStorage.getItem(
        "dataLocalHealthRecord"
      );
      let isSaved = await this.checkSaveDataLocal(
        dataLocalHealthRecord,
        data.PeopleCode
      );
      if (isSaved) {
        let dataLocal = JSON.parse(dataLocalHealthRecord);
        let dataUser = {};
        let indexUser = null;
        dataLocal.dataLocalHealthRecord.forEach((element, index) => {
          if (element.peopleCode == data.PeopleCode) {
            dataUser = element;
            indexUser = index;
          }
        });
        if (dataUser) {
          this.mData.listData = dataUser.dataKCB;
        }
        let dataDomain = [];
        // Chạy ngầm để lấy dữ liệu mới.
        // Lấy về danh sách các máy chủ.
        dataDomain = await this.fn_getAllDomain(data.PeopleCode);
        if (dataDomain.length > 0) {
          let dataReturn = [];
          let listRequest = [];
          // Call api để lấy về danh sách đợt khám chữa bệnh theo tùng domain.
          for (let i = 0; i < dataDomain.length; i++) {
            let urlDomain = dataDomain[i].UrlAddress;
            try {
              // console.log(token);
              var response = ApiServiceAxios({
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                },
                data: body,
                url: `${urlDomain}api/EHR/GetDotVaoVienByBoHanhChanh?token=${token}&ApplicationCode=${window.MyConfig.applicationCode831}`,
              });
              listRequest.push(response);
            } catch (error) {
              // console.log("có lỗi: ", error);
            }
          }
          if (listRequest.length > 0) {
            const dataRequest = await Promise.all(listRequest);
            // console.log("dataRequest", dataRequest);
            dataRequest.forEach((element) => {
              let domain = null;
              dataDomain.forEach((item) => {
                if (
                  element &&
                  element.config &&
                  element.config.url &&
                  element.config.url.includes(item.UrlAddress)
                ) {
                  domain = item.UrlAddress;
                }
              });
              if (
                element &&
                element.data &&
                element.data.Data &&
                element.data.Data.ThongTinVaoVien.length > 0
              ) {
                let data = element.data.Data.ThongTinVaoVien;
                data.forEach((item) => {
                  let object = {
                    id:
                      item.Encounter && item.Encounter.IdElement
                        ? item.Encounter.IdElement.Value
                        : "",
                    ma_noi_kham:
                      item.Organization &&
                      item.Organization.IdElement &&
                      item.Organization.IdElement.Value
                        ? item.Organization.IdElement.Value
                        : "",
                    noi_kham:
                      item.Organization &&
                      item.Organization.NameElement &&
                      item.Organization.NameElement.Value
                        ? item.Organization.NameElement.Value
                        : "",
                    ten_benh:
                      item.Condition &&
                      item.Condition.Text &&
                      item.Condition.Text.Div
                        ? item.Condition.Text.Div
                        : "",
                    ngay_bat_dau:
                      item.Encounter &&
                      item.Encounter.Period &&
                      item.Encounter.Period.StartElement &&
                      item.Encounter.Period.StartElement.Value
                        ? MethodService.formatDate(
                            item.Encounter.Period.StartElement.Value,
                            "date"
                          )
                        : "",
                    ngay_ket_thuc:
                      item.Encounter &&
                      item.Encounter.Period &&
                      item.Encounter.Period.EndElement &&
                      item.Encounter.Period.EndElement.Value
                        ? MethodService.formatDate(
                            item.Encounter.Period.EndElement.Value,
                            "date"
                          )
                        : "",
                    ngay_ket_thuc_date:
                      item.Encounter &&
                      item.Encounter.Period &&
                      item.Encounter.Period.EndElement &&
                      item.Encounter.Period.EndElement.Value
                        ? item.Encounter.Period.EndElement.Value
                        : null,
                    khoa_dieu_tri:
                      item.Location &&
                      item.Location.NameElement &&
                      item.Location.NameElement.Value
                        ? item.Location.NameElement.Value
                        : "",
                    kieu_dich_vu:
                      item.Encounter &&
                      item.Encounter.ServiceType &&
                      item.Encounter.ServiceType.Coding &&
                      item.Encounter.ServiceType.Coding.length > 0 &&
                      item.Encounter.ServiceType.Coding[0].CodeElement &&
                      item.Encounter.ServiceType.Coding[0].CodeElement.Value
                        ? item.Encounter.ServiceType.Coding[0].CodeElement.Value
                        : "",
                    so_ngay_kcb:
                      item.Encounter &&
                      item.Encounter.Length &&
                      item.Encounter.Length.ValueElement &&
                      item.Encounter.Length.ValueElement.Value
                        ? item.Encounter.Length.ValueElement.Value
                        : "",
                    tinh_trang_ra_vien: this.hanleTinhTrangRaVien(item),
                    danh_sach_benh: this.handleDanhSachBenh(item),
                    danh_sach_benh_kem_theo: this.handleDanhSachBenh(
                      item,
                      true
                    ),
                    danh_sach_cchn_bac_si: this.handleDanhSachCCHN(item),
                    domain: domain,
                  };
                  dataReturn.push(object);
                });
              }
            });
          }
          dataReturn = dataReturn.sort(function (a, b) {
            return (
              new Date(
                b.ngay_bat_dau.substring(6, 10),
                parseInt(b.ngay_bat_dau.substring(3, 5)) - 1,
                b.ngay_bat_dau.substring(0, 2)
              ).getTime() -
              new Date(
                a.ngay_bat_dau.substring(6, 10),
                parseInt(a.ngay_bat_dau.substring(3, 5)) - 1,
                a.ngay_bat_dau.substring(0, 2)
              ).getTime()
            );
          });
          if (dataReturn.length > 0) {
            let countOld = 0;
            dataLocal.dataLocalHealthRecord[indexUser].dataKCB.forEach(
              (item) => {
                dataReturn.forEach((element) => {
                  if (item.id == element.id) {
                    countOld++;
                  }
                });
              }
            );
            if (countOld > 0) {
              let countNew = dataReturn.length - countOld;
              if (countNew > 0) {
                Toast.show({
                  text: `Bạn có ${countNew} đợt KCB mới!`,
                  type: "success",
                  buttonText: "Ok",
                  duration: 5000,
                });
              }
            }
            dataLocal.dataLocalHealthRecord.splice(indexUser, 1);
            dataLocal.dataLocalHealthRecord.push({
              peopleCode: data.PeopleCode,
              dataKCB: dataReturn,
            });
            // console.log("dataLocalHealthRecord", dataLocal);
            await localStorage.setItem(
              "dataLocalHealthRecord",
              JSON.stringify(dataLocal)
            );
            this.mData.listData = dataReturn;
          } else {
            //Xóa dữ liệu đợt khám của tài khoản trong local khi api không trả về dữ liệu đợt khám nào.
            dataLocal.dataLocalHealthRecord.splice(indexUser, 1);
            await localStorage.setItem(
              "dataLocalHealthRecord",
              JSON.stringify(dataLocal)
            );
          }
        } else {
          //Xóa dữ liệu đợt khám của tài khoản trong local khi api không trả về domain.
          dataLocal.dataLocalHealthRecord.splice(indexUser, 1);
          await localStorage.setItem(
            "dataLocalHealthRecord",
            JSON.stringify(dataLocal)
          );
        }
      } else {
        if (!dataLocalHealthRecord) {
          dataLocalHealthRecord = [];
        } else {
          let data = JSON.parse(dataLocalHealthRecord);
          dataLocalHealthRecord = data.dataLocalHealthRecord;
        }
        let dataDomain = [];
        let token = MethodService.getToken();
        dataDomain = await this.fn_getAllDomain(data.PeopleCode);
        if (dataDomain.length > 0) {
          let dataReturn = [];
          let listRequest = [];
          for (let i = 0; i < dataDomain.length; i++) {
            let urlDomain = dataDomain[i].UrlAddress;
            try {
              // const response = Axios.post(
              //     `${urlDomain}api/EHR/GetDotVaoVienByBoHanhChanh?token=${token}&ApplicationCode=${severConfig.applicationCode831}`
              //     // `http://dwh-dev2.vietsens.vn/api/EHR/GetDotVaoVienByBoHanhChanh?token=${token}&ApplicationCode=${severConfig.applicationCode831}`
              //     , body,
              //     {
              //         headers: {
              //             'Content-Type': 'application/json'
              //         }
              //     }
              // )
              var response = ApiServiceAxios({
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                },
                url: `${urlDomain}api/EHR/GetDotVaoVienByBoHanhChanh?token=${token}&ApplicationCode=${window.MyConfig.applicationCode831}`,
                data: body,
              });
              listRequest.push(response);
            } catch (err) {
              // console.log("Lỗi call", err);
            }
          }
          if (listRequest.length > 0) {
            const dataRequest = await Promise.all(listRequest);
            // console.log("dataRequest", dataRequest);
            dataRequest.forEach((element) => {
              let domain = null;
              dataDomain.forEach((item) => {
                if (
                  element &&
                  element.config &&
                  element.config.url &&
                  element.config.url.includes(item.UrlAddress)
                ) {
                  domain = item.UrlAddress;
                }
              });
              if (
                element &&
                element.data &&
                element.data.Data &&
                element.data.Data.ThongTinVaoVien.length > 0
              ) {
                let data = element.data.Data.ThongTinVaoVien;
                data.forEach((item) => {
                  let object = {
                    id:
                      item.Encounter && item.Encounter.IdElement
                        ? item.Encounter.IdElement.Value
                        : "",
                    ma_noi_kham:
                      item.Organization &&
                      item.Organization.IdElement &&
                      item.Organization.IdElement.Value
                        ? item.Organization.IdElement.Value
                        : "",
                    noi_kham:
                      item.Organization &&
                      item.Organization.NameElement &&
                      item.Organization.NameElement.Value
                        ? item.Organization.NameElement.Value
                        : "",
                    ten_benh:
                      item.Condition &&
                      item.Condition.Text &&
                      item.Condition.Text.Div
                        ? item.Condition.Text.Div
                        : "",
                    ngay_bat_dau:
                      item.Encounter &&
                      item.Encounter.Period &&
                      item.Encounter.Period.StartElement &&
                      item.Encounter.Period.StartElement.Value
                        ? MethodService.formatDate(
                            item.Encounter.Period.StartElement.Value,
                            "date"
                          )
                        : "",
                    ngay_ket_thuc:
                      item.Encounter &&
                      item.Encounter.Period &&
                      item.Encounter.Period.EndElement &&
                      item.Encounter.Period.EndElement.Value
                        ? MethodService.formatDate(
                            item.Encounter.Period.EndElement.Value,
                            "date"
                          )
                        : "",
                    ngay_ket_thuc_date:
                      item.Encounter &&
                      item.Encounter.Period &&
                      item.Encounter.Period.EndElement &&
                      item.Encounter.Period.EndElement.Value
                        ? item.Encounter.Period.EndElement.Value
                        : null,
                    khoa_dieu_tri:
                      item.Location &&
                      item.Location.NameElement &&
                      item.Location.NameElement.Value
                        ? item.Location.NameElement.Value
                        : "",
                    kieu_dich_vu:
                      item.Encounter &&
                      item.Encounter.ServiceType &&
                      item.Encounter.ServiceType.Coding &&
                      item.Encounter.ServiceType.Coding.length > 0 &&
                      item.Encounter.ServiceType.Coding[0].CodeElement &&
                      item.Encounter.ServiceType.Coding[0].CodeElement.Value
                        ? item.Encounter.ServiceType.Coding[0].CodeElement.Value
                        : "",
                    so_ngay_kcb:
                      item.Encounter &&
                      item.Encounter.Length &&
                      item.Encounter.Length.ValueElement &&
                      item.Encounter.Length.ValueElement.Value
                        ? item.Encounter.Length.ValueElement.Value
                        : "",
                    tinh_trang_ra_vien: this.hanleTinhTrangRaVien(item),
                    danh_sach_benh: this.handleDanhSachBenh(item),
                    danh_sach_benh_kem_theo: this.handleDanhSachBenh(
                      item,
                      true
                    ),
                    danh_sach_cchn_bac_si: this.handleDanhSachCCHN(item),
                    domain: domain,
                  };
                  dataReturn.push(object);
                });
              }
            });
          }
          dataReturn = dataReturn.sort(function (a, b) {
            return (
              new Date(
                b.ngay_bat_dau.substring(6, 10),
                parseInt(b.ngay_bat_dau.substring(3, 5)) - 1,
                b.ngay_bat_dau.substring(0, 2)
              ).getTime() -
              new Date(
                a.ngay_bat_dau.substring(6, 10),
                parseInt(a.ngay_bat_dau.substring(3, 5)) - 1,
                a.ngay_bat_dau.substring(0, 2)
              ).getTime()
            );
          });
          if (dataReturn.length > 0) {
            // console.log("dataLocalHealthRecord", dataLocalHealthRecord);
            dataLocalHealthRecord.push({
              peopleCode: data.PeopleCode,
              dataKCB: dataReturn,
            });
            await localStorage.setItem(
              "dataLocalHealthRecord",
              JSON.stringify({ dataLocalHealthRecord })
            );
          }
          this.mData.listData = dataReturn;
          // console.log(dataReturn);
        }
      }
    },
    hanleTinhTrangRaVien(item) {
      let listTTRV = [];
      if (item.Observations.length > 0) {
        item.Observations.forEach((element) => {
          let obj = {
            idTinhTrangRaVien: "",
            textTinhTrangRaVien: "",
          };
          if (
            element.Code &&
            element.Code.Coding &&
            element.Code.Coding.length > 0 &&
            element.Code.Coding[0].CodeElement &&
            element.Code.Coding[0].CodeElement.Value &&
            element.Code.Coding[0].CodeElement.Value == "52523-8"
          ) {
            obj.idTinhTrangRaVien =
              element.Identifier &&
              element.Identifier.length > 0 &&
              element.Identifier[0].ValueElement &&
              element.Identifier[0].ValueElement.Value
                ? element.Identifier[0].ValueElement.Value
                : "";
            obj.textTinhTrangRaVien =
              element.Text && element.Text.Div ? element.Text.Div : "";
          }
          listTTRV.push(obj);
        });
      }
      return listTTRV;
    },
    handleDanhSachBenh(item, isBenhKemTheo) {
      let listBenh = [];
      if (
        item.Condition &&
        item.Condition.Code &&
        item.Condition.Code.Coding &&
        item.Condition.Code.Coding.length > 0
      ) {
        item.Condition.Code.Coding.forEach((element) => {
          if (element.DisplayElement && element.DisplayElement.Value) {
            listBenh.push(element.DisplayElement.Value);
          }
        });
      }
      if (isBenhKemTheo && listBenh.length > 0) {
        listBenh.shift();
      }
      return listBenh;
    },
    handleDanhSachCCHN(item) {
      let listCCHN = [];
      if (
        item.Encounter &&
        item.Encounter.Participant &&
        item.Encounter.Participant.length > 0
      ) {
        item.Encounter.Participant.forEach((element) => {
          if (element.ElementId) {
            let arr = element.ElementId.split(";");
            if (arr.length > 0) {
              arr.forEach((item) => {
                listCCHN.push(item.trim());
              });
            }
          }
        });
      }
      let dataFillter = [];
      if (listCCHN.length > 0) {
        listCCHN.forEach((item, index) => {
          let fillter = dataFillter.find((el) => el == item);
          if (!fillter) {
            dataFillter.push(item);
          }
        });
      }
      return dataFillter;
    },
  },

  //run after render view
  created() {},
  mounted() {
    this.fn_initData();
  },
};
</script>

<style scoped>
</style>